module.exports = __webpack_public_path__ + "img/image-15.6af3911e.jpg";